import React, { useState } from "react";

const Hero = ({ title }) => {
  const [toTop, setToTop] = useState(false);

  const scrollToTop = () => {
    if (window.scrollY >= 500) {
      //if scroll >= 1px
      setToTop(true);
    } else {
      setToTop(false);
    }
  };

  window.addEventListener("scroll", scrollToTop);

  return (
    <>
      <div className="hero" id="hero">
        <div className="mask">
          <img
            className="intro-img"
            src="https://wallpapercave.com/wp/wp7840957.jpg"
            alt="Intro Img"
          />
          <h1>{title}</h1>
        </div>
      </div>
      <a href="#hero" className={toTop ? "to-top on" : "to-top"}>
        <i class="fa-solid fa-chevron-up fa-fade"></i>
      </a>
    </>
  );
};

export default Hero;
